module.exports = __webpack_public_path__ + "static/media/loading.861c5b86.svg";